import React from 'react';
import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import type { StoreParcelShopResult } from 'autogen/swagger/all';
import { FewInStock, IsInStock, SoldOut } from 'autogen/translation-keys/trans-website-productstoresearch-productstock';
import Tag from 'components/generic/tag';
import { Typography } from 'components/generic/typography';
import Status from 'components/Status';

export type StatusRendererProps = {
    status:
        | StoreParcelShopResult['productStockStatus']
        | 'Unavailable'
        | 'Available'
        | 'NotRelevant'
        | 'AllAvailable'
        | 'SomeUnavailable';
    statusTag?: string;
    showUnavailableStatus?: boolean;
    showText?: boolean;
};

const Wrapper = styled.div`
    display: inline-flex;
    gap: ${({ theme }) => theme.Spacing8};
    align-items: center;
`;

function StatusRenderer(props: StatusRendererProps) {
    const { status, statusTag, showUnavailableStatus, showText = false } = props;
    const { t } = useTranslation();

    switch (status) {
        case 'IsInStock':
        case 'Available':
        case 'AllAvailable':
            return (
                <Wrapper>
                    {statusTag ? <Tag text={statusTag} /> : <Status color="Green" size={12} />}
                    {showText && <Typography.Body as="span">{t(IsInStock)}</Typography.Body>}
                </Wrapper>
            );
        case 'FewInStock':
            return (
                <Wrapper>
                    {statusTag ? <Tag text={statusTag} /> : <Status.HalfFilled color="Green" size={12} />}
                    {showText && <Typography.Body as="span">{t(FewInStock)}</Typography.Body>}
                </Wrapper>
            );
        case 'SomeUnavailable':
            return (
                <Wrapper>
                    <Status color="Yellow" size={12} />
                </Wrapper>
            );
        case 'SoldOut':
        case 'Unavailable':
            return (
                <Wrapper>
                    {showUnavailableStatus && <Status.CrossOut color="Red" size={12} />}
                    {showText && <Typography.Body as="span">{t(SoldOut)}</Typography.Body>}
                </Wrapper>
            );
        case 'NotRelevant':
        default:
            break;
    }
}

export default StatusRenderer;
